import api from "./fetch";
import TokenService from "./token.service";

class AuthService {
    login({email, password}: { email: string; password: string }) {
        return api
            .post("auth/login/", {
                email,
                password
            })
            .then((response) => {
                if (response.data.access) {
                    TokenService.setUser(response.data.access, response.data.refresh);


                }

                return response.data;
            });
    }

    logout() {
        TokenService.removeUser();
    }
}

export default new AuthService();
